import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useSettings() {
  return useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get(`/settings?_=${Date.now()}`)).data,
    staleTime: 30 * 1000,
  });
}
